import FileName from '../../ComControl/FileName'
import AvgButtonIndex from '../../ComControl/AvgButtonIndex'
import AvgButton from '../../ComControl/AvgButton'
import Viewport from '../../ComControl/Viewport'
import BGMItem from './BGMItem'
import { FileReader, FileWriter } from '@/platform'
import DataUtils from '../../DataUtils'
import { normalizeString, writeIntBool } from '../../gameBinUtils'

class BGMAppreciate {
    /**
     * 界面的背景图片1
     */
    public BackPic: FileName = new FileName({ type: FileName.DEF_TYPE, name: 'BGM.png' })

    /**
     * BGM结构集合
     */
    public BGMs: BGMItem[] = [new BGMItem()]

    /**
     * 选择BGM时候的按钮样式1  project_bin_no
     */
    public Button: AvgButton = new AvgButton()

    /**
     *
     */
    public ButtonEx: AvgButtonIndex = new AvgButtonIndex()

    /**
     *
     */
    public CloseButtonEx: AvgButtonIndex = new AvgButtonIndex()

    /**
     * 分为几列1
     */
    public Column: number = 2

    /**
     * 行间距1
     */
    public SpanRow: number = 0

    /**
     * 列间距1
     */
    public SpanCol: number = 310

    /**
     * 是否显示BGM对应的图片1
     */
    public IsPic: boolean = true

    /**
     * 是否显示BGM的文本介绍1
     */
    public IsMsg: boolean = true

    public P_x: number = 450

    /**
     * 图片位置的x,y坐标1
     */
    public P_y: number = 120

    /**
     *  文本介绍的x坐标
     */
    public X: number = 465

    /**
     * 文本介绍的x
     */
    public Y: number = 420

    /**
     * BGM名称的X坐标Y坐标1
     */
    public N_x: number = 5

    /**
     * BGM名称的X坐标Y坐标1
     */
    public N_y: number = 3

    /**
     * BGM未开启时的名称
     */
    public NoName: string = 'none'

    /**
     * BGM未开启时的封面1
     */
    public NoPic: FileName = new FileName()

    /**
     * 限制显示的Viewport对象1
     */
    public Viewport: Viewport = new Viewport()

    /**
     * 关闭窗口的按钮1  project_bin_no
     */
    public CloseButton: AvgButton = new AvgButton()

    /**
     * 按钮对应的索引1  project_bin_no
     */
    public BtnIndex: number[] = []

    public NameList: { name: string; startIndex: number }[] = [{ name: 'BGM鉴赏1', startIndex: 0 }]

    public ListBtnIndex: AvgButtonIndex = new AvgButtonIndex()

    public ListBtnGap: number = 0

    /** 列表按钮排列方向 0:横向 1:纵向 */
    public ListBtnDirection: number = 0

    /** 背景缩放比例0~100的数字 */
    public BgScale: number = 100
    

    constructor(param?: AvgButton[]) {
      if (!param) return
      this.BackPic = new FileName({ type: FileName.DEF_TYPE, name: 'BGM.png' })
      this.BGMs = [new BGMItem()]
      for (let i: number = 0; i < 3; i++) {
        this.BGMs.push(new BGMItem({ name: '', bgmPath: '', bitmapPath: '', msg: '' }))
      }
      this.Button = param[0]!
      this.Column = 2
      this.SpanRow = 40
      this.SpanCol = 310
      this.IsPic = true
      this.IsMsg = true
      this.P_x = 450
      this.P_y = 120
      this.X = 465
      this.Y = 420
      this.N_x = 5
      this.N_y = 3
      this.NoName = 'none'
      this.NoPic = new FileName({ type: FileName.DEF_TYPE, name: '' })
      this.Viewport = new Viewport(10, 100, 300, 400)
      this.CloseButton = param[1]!
      this.BtnIndex = [24, 15]
      this.ButtonEx = new AvgButtonIndex(24, this.Button?.X, this.Button?.Y)
      this.CloseButtonEx = new AvgButtonIndex(15, this.CloseButton?.X, this.CloseButton?.Y)
    }

    /**
     * 与 cg_v3_data BGMAppreciate @DataStrucrParse 序号 1～21 一致；≥114 时追加 NameList 等（同库 readfromBin 尾部）
     */
    readBin(reader: FileReader): void {
      this.BackPic = new FileName(reader)
      this.BGMs = []
      const bgmLen = reader.readInt()
      for (let i = 0; i < bgmLen; i++) {
        const BGM = new BGMItem()
        BGM.readBin(reader)
        this.BGMs.push(BGM)
      }
      this.Button = new AvgButton()
      this.Button.readBin(reader)
      this.ButtonEx = new AvgButtonIndex()
      this.ButtonEx.readBin(reader)
      this.CloseButtonEx = new AvgButtonIndex()
      this.CloseButtonEx.readBin(reader)
      this.Column = reader.readInt()
      this.SpanRow = reader.readInt()
      this.SpanCol = reader.readInt()
      this.IsPic = reader.readBool()
      this.IsMsg = reader.readBool()
      this.P_x = reader.readInt()
      this.P_y = reader.readInt()
      this.X = reader.readInt()
      this.Y = reader.readInt()
      this.N_x = reader.readInt()
      this.N_y = reader.readInt()
      this.NoName = reader.readString()
      this.NoPic = new FileName(reader)
      this.Viewport = new Viewport()
      this.Viewport.readBin(reader)
      this.CloseButton = new AvgButton()
      this.CloseButton.readBin(reader)
      const btnIdxLen = reader.readInt()
      this.BtnIndex = []
      for (let i = 0; i < btnIdxLen; i++) {
        this.BtnIndex.push(reader.readInt())
      }
      if (DataUtils.dataVersion >= 114) {
        const len = reader.readInt()
        this.NameList = []
        for (let i = 0; i < len; i++) {
          this.NameList.push({ name: reader.readString(), startIndex: reader.readInt() })
        }
        if (this.NameList.length === 0) {
          this.NameList = [{ name: 'BGM鉴赏1', startIndex: 0 }]
        }
        this.ListBtnIndex = new AvgButtonIndex()
        this.ListBtnIndex.readBin(reader)
        this.ListBtnGap = reader.readInt()
        this.ListBtnDirection = reader.readInt()
        this.BgScale = reader.readInt()
      }
    }

    writeBin(writer: FileWriter): void {
      this.BackPic.writeBin(writer)
      writer.writeInt(this.BGMs.length)
      for (let i = 0; i < this.BGMs.length; i++) {
        this.BGMs[i]!.writeBin(writer)
      }
      this.Button.writeBin(writer)
      this.ButtonEx.writeBin(writer)
      this.CloseButtonEx.writeBin(writer)
      writer.writeInt(this.Column)
      writer.writeInt(this.SpanRow)
      writer.writeInt(this.SpanCol)
      writer.writeBool(this.IsPic)
      writer.writeBool(this.IsMsg)
      writer.writeInt(this.P_x)
      writer.writeInt(this.P_y)
      writer.writeInt(this.X)
      writer.writeInt(this.Y)
      writer.writeInt(this.N_x)
      writer.writeInt(this.N_y)
      writer.writeString(this.NoName)
      this.NoPic.writeBin(writer)
      this.Viewport.writeBin(writer)
      this.CloseButton.writeBin(writer)
      writer.writeInt(this.BtnIndex.length)
      for (let i = 0; i < this.BtnIndex.length; i++) {
        writer.writeInt(this.BtnIndex[i]!)
      }
      if (DataUtils.dataVersion >= 114) {
        writer.writeInt(this.NameList.length)
        for (const item of this.NameList) {
          writer.writeString(item.name)
          writer.writeInt(item.startIndex)
        }
        this.ListBtnIndex.writeBin(writer)
        writer.writeInt(this.ListBtnGap)
        writer.writeInt(this.ListBtnDirection)
        writer.writeInt(this.BgScale)
      }
    }

  readVersionedOui(reader: FileReader, dataVersion: number): void {
      this.BackPic.readVersionedOui(reader.readObj(reader.readInt()))
      this.Column = reader.readInt()
      this.SpanRow = reader.readInt()
      this.SpanCol = reader.readInt()
      this.IsPic = reader.readInt() == 1 ? true : false
      this.IsMsg = reader.readInt() == 1 ? true : false
      this.P_x = reader.readInt()
      this.P_y = reader.readInt()
      this.X = reader.readInt()
      this.Y = reader.readInt()
      this.N_x = reader.readInt()
      this.N_y = reader.readInt()
      this.NoName = reader.readString()
      this.NoPic.readVersionedOui(reader.readObj(reader.readInt()))

      this.BGMs = []
      const bgmLen = reader.readInt()
      for (var i = 0; i < bgmLen; i++) {
          let BGM = new BGMItem()
          BGM.readVersionedOui(reader.readObj(reader.readInt()))
          this.BGMs.push(BGM)
      }

      this.Viewport.readVersionedOui(reader.readObj(reader.readInt()))
      this.ButtonEx.readVersionedOui(reader.readObj(reader.readInt()))
      this.CloseButtonEx.readVersionedOui(reader.readObj(reader.readInt()))
      if (dataVersion >= 115) {
          const len = reader.readInt()
          if (len > 0) {
              this.NameList = []
          }
          for (let i = 0; i < len; i++) {
              this.NameList.push({ name: reader.readString(), startIndex: reader.readInt() })
          }
          this.ListBtnIndex.readVersionedOui(reader.readObj(reader.readInt()))
          this.ListBtnGap = reader.readInt()
          this.ListBtnDirection = reader.readInt()
          this.BgScale = reader.readInt()
      }
  }

  writeVersionedOui(writer: FileWriter, dataVersion: number): void {
      writer.writerIntLength()

      this.BackPic.writeVersionedOui(writer)
      writer.writeInt(this.Column)
      writer.writeInt(this.SpanRow)
      writer.writeInt(this.SpanCol)
      writer.writeInt(this.IsPic ? 1 : 0)
      writer.writeInt(this.IsMsg ? 1 : 0)
      writer.writeInt(this.P_x)
      writer.writeInt(this.P_y)
      writer.writeInt(this.X)
      writer.writeInt(this.Y)
      writer.writeInt(this.N_x)
      writer.writeInt(this.N_y)
      writer.writeString(this.NoName)
      this.NoPic.writeVersionedOui(writer)

      writer.writeInt(this.BGMs.length)
      for (let i = 0; i < this.BGMs.length; i++) {
          const BGM = this.BGMs[i]
          BGM.writeVersionedOui(writer)
      }

      this.Viewport.writeVersionedOui(writer)
      this.ButtonEx.writeVersionedOui(writer)
      this.CloseButtonEx.writeVersionedOui(writer)
      if (dataVersion >= 115) {
          writer.writeInt(this.NameList.length)
          this.NameList.forEach(item => {
              writer.writeString(item.name)
              writer.writeInt(item.startIndex)
          })
          this.ListBtnIndex.writeVersionedOui(writer)
          writer.writeInt(this.ListBtnGap)
          writer.writeInt(this.ListBtnDirection)
          writer.writeInt(this.BgScale)
      }

      writer.writerLength()
  }

  writeGameBin(writer: FileWriter, engineVersion: number): void {
      writer.writerIntLength()
      this.BackPic.writeVersionedOui(writer)
      writer.writeInt(Number(this.Column || 0))
      writer.writeInt(Number(this.SpanRow || 0))
      writer.writeInt(Number(this.SpanCol || 0))
      writeIntBool(writer, this.IsPic)
      writeIntBool(writer, this.IsMsg)
      writer.writeInt(Number(this.P_x || 0))
      writer.writeInt(Number(this.P_y || 0))
      writer.writeInt(Number(this.X || 0))
      writer.writeInt(Number(this.Y || 0))
      writer.writeInt(Number(this.N_x || 0))
      writer.writeInt(Number(this.N_y || 0))
      writer.writeString(normalizeString(this.NoName))
      this.NoPic.writeVersionedOui(writer)

      const items = Array.isArray(this.BGMs) ? this.BGMs : []
      writer.writeInt(items.length)
      for (let i = 0; i < items.length; i++) {
          items[i]?.writeGameBin(writer)
      }

      this.Viewport.writeVersionedOui(writer)
      this.ButtonEx.writeVersionedOui(writer)
      this.CloseButtonEx.writeVersionedOui(writer)

      if (engineVersion >= 110) {
          const nameList = Array.isArray(this.NameList) ? this.NameList : []
          writer.writeInt(nameList.length)
          for (let i = 0; i < nameList.length; i++) {
              const item = nameList[i]
              writer.writeString(normalizeString(item?.name))
              writer.writeInt(Number(item?.startIndex || 0))
          }
          this.ListBtnIndex.writeVersionedOui(writer)
          writer.writeInt(Number(this.ListBtnGap || 0))
          writer.writeInt(Number(this.ListBtnDirection || 0))
          writer.writeInt(Number(this.BgScale || 0))
      }

      writer.writerLength()
  }
}

export default BGMAppreciate
